var map = {
	"./acc1_1.png": 8284,
	"./acc1_2.png": 6391,
	"./acc1_3.png": 814,
	"./acc1_4.png": 8529,
	"./acc2_1.png": 3979,
	"./acc2_2.png": 160,
	"./acc2_3.png": 6409,
	"./acc2_4.png": 3990,
	"./bg.webp": 1934,
	"./card1.jpg": 2217,
	"./card2.jpg": 9134,
	"./card3.jpg": 619,
	"./card4.jpg": 8235,
	"./card5.jpg": 7781,
	"./coin.png": 8107,
	"./logo.png": 3153,
	"./main.png": 8823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;